/* ============================================================================
   Aquarylic Mobile Menu Fix
   Version: 1.0.0
   Theme: Broadcast 8.1.1
   Purpose:
   - Prevent Broadcast theme.js null dispatchEvent error when native #header-menu
     drawer is missing.
   - Provides a lightweight fallback drawer for the mobile hamburger.
   ============================================================================ */

(function () {
  'use strict';

  if (window.__aqMobileMenuFixLoaded) return;
  window.__aqMobileMenuFixLoaded = true;

  var SELECTORS = {
    burger: '.header__mobile__hamburger[data-drawer-toggle="hamburger"], .header__mobile__hamburger[aria-controls="header-menu"]',
    nativeMenu: '#header-menu, [data-drawer="hamburger"]',
    desktopMenu: '.header__desktop .header__menu',
    toolbarMenu: '.toolbar__menu',
    drawer: '#aq-mobile-menu-fallback'
  };

  function hasNativeMenu() {
    return Boolean(document.querySelector(SELECTORS.nativeMenu));
  }

  function getBurger() {
    return document.querySelector(SELECTORS.burger);
  }

  function createCloseButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'aq-mobile-menu-fallback__close';
    button.setAttribute('aria-label', 'Menü schließen');
    button.innerHTML = '×';
    return button;
  }

  function createMenuLink(link, levelClass) {
    var item = document.createElement('a');
    item.className = 'aq-mobile-menu-fallback__link ' + (levelClass || '');
    item.href = link.href || '#';
    item.textContent = (link.textContent || '').trim();

    if (!item.textContent) {
      item.textContent = link.getAttribute('aria-label') || 'Link';
    }

    return item;
  }

  function collectMenuLinks() {
    var links = [];
    var seen = new Set();

    var desktopMenu = document.querySelector(SELECTORS.desktopMenu);

    if (desktopMenu) {
      desktopMenu.querySelectorAll('a[href]').forEach(function (link) {
        var text = (link.textContent || '').trim();
        var href = link.getAttribute('href') || '';

        if (!text || !href || href === '#') return;

        var key = text + '|' + href;
        if (seen.has(key)) return;
        seen.add(key);

        links.push({
          element: link,
          level: link.classList.contains('navlink--grandchild') ? 'grandchild' :
                 link.classList.contains('navlink--child') ? 'child' :
                 'top'
        });
      });
    }

    var toolbarMenu = document.querySelector(SELECTORS.toolbarMenu);

    if (toolbarMenu) {
      toolbarMenu.querySelectorAll('a[href]').forEach(function (link) {
        var text = (link.textContent || '').trim();
        var href = link.getAttribute('href') || '';

        if (!text || !href || href === '#') return;

        var key = text + '|' + href;
        if (seen.has(key)) return;
        seen.add(key);

        links.push({
          element: link,
          level: 'secondary'
        });
      });
    }

    return links;
  }

  function buildFallbackDrawer() {
    var existing = document.querySelector(SELECTORS.drawer);
    if (existing) return existing;

    var drawer = document.createElement('div');
    drawer.id = 'aq-mobile-menu-fallback';
    drawer.className = 'aq-mobile-menu-fallback';
    drawer.setAttribute('aria-hidden', 'true');

    var overlay = document.createElement('button');
    overlay.type = 'button';
    overlay.className = 'aq-mobile-menu-fallback__overlay';
    overlay.setAttribute('aria-label', 'Menü schließen');

    var panel = document.createElement('div');
    panel.className = 'aq-mobile-menu-fallback__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Menü');

    var header = document.createElement('div');
    header.className = 'aq-mobile-menu-fallback__header';

    var title = document.createElement('div');
    title.className = 'aq-mobile-menu-fallback__title';
    title.textContent = 'Menü';

    var close = createCloseButton();

    var nav = document.createElement('nav');
    nav.className = 'aq-mobile-menu-fallback__nav';
    nav.setAttribute('aria-label', 'Mobiles Menü');

    collectMenuLinks().forEach(function (entry) {
      var levelClass = 'aq-mobile-menu-fallback__link--' + entry.level;
      nav.appendChild(createMenuLink(entry.element, levelClass));
    });

    if (!nav.children.length) {
      [
        ['Shop', '/collections/alle-produkte'],
        ['Aquarylic Color', '/collections/aquarylic-color#productgrid'],
        ['Acrylfarbe', '/collections/acrylfarbe#productgrid'],
        ['Kreidefarbe', '/collections/kreidefarbe#productgrid'],
        ['Gels & Medien', '/collections/gels-medien#category'],
        ['Zubehör & Gutscheine', '/collections/zubehor#category'],
        ['Aquarylic Academy', '/pages/aquarylic-academy'],
        ['Kontakt', '/pages/contact']
      ].forEach(function (item) {
        var link = document.createElement('a');
        link.className = 'aq-mobile-menu-fallback__link aq-mobile-menu-fallback__link--top';
        link.href = item[1];
        link.textContent = item[0];
        nav.appendChild(link);
      });
    }

    header.appendChild(title);
    header.appendChild(close);
    panel.appendChild(header);
    panel.appendChild(nav);

    drawer.appendChild(overlay);
    drawer.appendChild(panel);

    document.body.appendChild(drawer);

    overlay.addEventListener('click', closeDrawer);
    close.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link) return;
      closeDrawer();
    });

    return drawer;
  }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('aq-mobile-menu-fallback-is-open', lock);
    document.body.classList.toggle('aq-mobile-menu-fallback-is-open', lock);
  }

  function openDrawer() {
    var drawer = buildFallbackDrawer();
    var burger = getBurger();

    drawer.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');

    if (burger) {
      burger.setAttribute('aria-expanded', 'true');
    }

    lockScroll(true);

    window.setTimeout(function () {
      var firstLink = drawer.querySelector('a[href], button');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }, 80);
  }

  function closeDrawer() {
    var drawer = document.querySelector(SELECTORS.drawer);
    var burger = getBurger();

    if (!drawer) return;

    drawer.setAttribute('aria-hidden', 'true');
    drawer.classList.remove('is-open');

    if (burger) {
      burger.setAttribute('aria-expanded', 'false');
      burger.focus({ preventScroll: true });
    }

    lockScroll(false);
  }

  function handleBurgerClick(event) {
    var burger = event.target.closest(SELECTORS.burger);
    if (!burger) return;

    /*
      If Broadcast's native drawer exists, do not interfere.
      If it is missing, prevent theme.js from hitting null.dispatchEvent.
    */
    if (hasNativeMenu()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    openDrawer();
  }

  function handleKeydown(event) {
    if (event.key !== 'Escape') return;

    var drawer = document.querySelector(SELECTORS.drawer);
    if (!drawer || !drawer.classList.contains('is-open')) return;

    closeDrawer();
  }

  function init() {
    document.addEventListener('click', handleBurgerClick, true);
    document.addEventListener('keydown', handleKeydown, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();